import Status from 'clarks/components/ivu-table/status'

let forms = {
   addTableMain: {
      icon: 'fa fa-university',
      title: 'Add Table Main',
      subtitle: 'Provide Table Main Details',
      forms: [
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_accessible", label: "Is Accessible", },
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_db_configured", label: "Is Db Configured", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "alias", label: "Alias", },
         {
            type: "select",
            class: "col-12 col-md-6",
            filterable: false,
            clearable: true,
            options: [
               { val: "individual", label: "Individual", },
            ],
            validation: "required",
            model: "unique_field",
            label: "Unique Field",
         },

      ]
   },
   editTableMain: {
      icon: 'fa fa-university',
      title: 'Edit Table Main',
      subtitle: 'Update Table Main Details',
      forms: [
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_accessible", label: "Is Accessible", },
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_db_configured", label: "Is Db Configured", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "alias", label: "Alias", },
         {
            type: "select",
            class: "col-12 col-md-6",
            filterable: false,
            clearable: true,
            options: [
               { val: "individual", label: "Individual", },
            ],
            validation: "required",
            model: "unique_field",
            label: "Unique Field",
         },

      ]
   },
}

let tables = {
   table_main: {
      props: {
         icon: 'fa fa-database',
         title: 'Table Main',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['alias', 'unique_field', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Alias", key: "alias", },
            { title: "Unique Field", key: "unique_field", },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'table_main:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'table_main:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}